import * as types from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    isFetching: false,
    entities: {}
};

const requestSystemPreference = (state) => {
    return {
        ...state,
        isFetching: true
    };
};

const receiveSystemPreference = (state, data) => {
    return {
        ...state,
        isFetching: false,
        entities: {
            ...state.entities,
            [data.key]: data.preference.value
        },
        lastUpdated: data.receivedAt
    };
};

export const getSystemPreference = (state, key) => {
    return {
        key: [key],
        value: state.systemPreference.entities[key] || null
    };
};

export const getSystemPreferenceValue = (state, key) => {
    return state.systemPreference.entities[key] || null;
};

export const getSystemPreferenceIsFetching = (state) => {
    return state.systemPreference.isFetching;
};

const handlers = {
    [types.RECEIVE_SYSTEM_PREFERENCE]: receiveSystemPreference,
    [types.REQUEST_SYSTEM_PREFERENCE]: requestSystemPreference
};

export default function systemPreference(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;

    return handler(state, action);
}
